<script lang="ts">
  import * as AlertDialog from "$lib/components/ui/alert-dialog";

  let { open = $bindable(false), title = "Alert", message = "", actionLabel = "OK" } = $props();
</script>

<AlertDialog.Root bind:open>
  <AlertDialog.Content class="sm:max-w-[425px]">
    <AlertDialog.Header>
      <AlertDialog.Title>{title}</AlertDialog.Title>
      <AlertDialog.Description>
        {message}
      </AlertDialog.Description>
    </AlertDialog.Header>
    <AlertDialog.Footer>
      <AlertDialog.Action onclick={() => (open = false)}>
        {actionLabel}
      </AlertDialog.Action>
    </AlertDialog.Footer>
  </AlertDialog.Content>
</AlertDialog.Root>
